import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useWebSocket from "react-use-websocket";
import { useNavigate, useLocation } from "react-router-dom";
import { useLoadScript } from "@react-google-maps/api";
import { Grid, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { shareTrip } from "redux/actions/UserTrip";
import PickUp from "components/pickAndDrop/PickUp";
import WrappedMap from "components/commonMap/CommonMap";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import Lottify from "pages/lottify/lottify";
import carProfile from "assets/images/RideTrackCar.svg";
import driverVerified from "assets/images/driverVerified.svg";
import checkVerified from "assets/images/checkCircle.svg";
import greyCall from "assets/images/greyCall.svg";


function TripDetails() {
  const navigate = useNavigate();
  const [pathDetails, setPathDetails] = useState([]);
  const [pathDetailsnew, setPathDetailsnew] = useState(null);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  });

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tripId = queryParams.get('tripId');
  const cid = queryParams.get('cid');

  const tripDetails = useSelector((state) => state?.userShareTrip?.userShareTrip?.data);
  // const pathDetailsnew = {
  //   "location": {
  //     // "lat": 12.923,
  //     // "lng": 77.6015,
  //     // "heading": 135,
  //     "polylines": {
  //       "trip": {
  //         "points": tripDetails.polyLine.coordinates[0].map((cord) => {
  //           return { lat: cord[0], lng: cord[1] }
  //         })
  //       }
  //     }
  //   }
  // };
  useEffect(() => {
    if (tripDetails?.polyLine?.coordinates?.[0]) {
      setPathDetailsnew({
        "location": {
          "polylines": {
            "trip": {
              "points": tripDetails.polyLine.coordinates[0].map((cord) => {
                return { lat: cord[0], lng: cord[1] }
              })
            }
          }
        }
      });
    }
  }, [tripDetails]);
  let startlocation = tripDetails?.sourceLocation;
  let endLocation = tripDetails?.destinationLocation || tripDetails?.sourceLocation;
  let stop = startlocation?.coordinates && endLocation?.coordinates ? [
    { lat: startlocation.coordinates[0], lng: startlocation.coordinates[1] },
    { lat: endLocation.coordinates[0], lng: endLocation.coordinates[1] },
  ] : [];


  const dispatch = useDispatch();
  const mapURL = `https://staging.iter.co.in/trip-api/v1/maps`;

  const webSocketUrl = `${process.env.REACT_APP_WEBSOCKET_URL}?tripId=${tripId}&cid=${cid}`;

  useEffect(() => {
    if (tripId && cid) {
      const shareData = {
        tripId: tripId,
        cid: cid
      };
      dispatch(shareTrip(shareData));
    }
  }, [dispatch, tripId, cid]);

  useWebSocket(webSocketUrl, {
    onOpen: (e) => {
      console.log("WebSocket Connect has Established..!!!", e);
    },
    onMessage: (event) => {
      const eventData = JSON.parse(event.data);
      const tripStatus = (tripDetails?.status || "").toLowerCase();

      if (tripStatus === 'ongoing' || tripStatus === 'dispatched') {
        if (eventData?.location?.lat && eventData?.location?.lat !== null) {
          setPathDetails(eventData);
        }
      }
      else if (tripStatus !== 'ongoing' && tripStatus !== 'dispatched') {
        setPathDetails();
      }
    },
    onError: (error) => {
      console.error("WebSocket connection error:", error);
    }
  });

  const onPrivacyPolicy = () => {
    navigate('/privacy-policy');
  }

  const handleOnError = (e) => {
    e.target.src = carProfile;
  }


  // Extract driver profile data with NA defaults
  const driverProfile = tripDetails?.DriverProfile || {};
  const vehicleData = driverProfile?.Vehicle || {};
  const authData = driverProfile?.Auth || {};
  const tripStatus = tripDetails?.status || "NA";
 
  return (
    <>
      <Grid
        container
        xs={12}
        flexDirection="row"
        className="h100"
      >
        <Grid item md={4} xs={12} className="mt45ml20 order1">
          <PickUp tableData={tripDetails} />
          <hr />
          <Grid
            item
            container
            xs={12}
            flexDirection="row"
            justifyContent="space-evenly"
            alignItems="center"
          >
            <Grid item md={5} xs={6} sm={5}>
              <img
                src={vehicleData?.avtar?.url || carProfile}
                onError={handleOnError}
                alt="WhiteCar"
                className="assignedDriverImg"
              />
              <Typography className="font16 colorBlue">
                <img
                  className="marginBottom5"
                  src={driverVerified}
                  alt="vector"
                />
                {driverProfile?.driverName || "NA"}
              </Typography>
              <Typography className="colorGrey font14">
                Top-rated Driver
              </Typography>
            </Grid>
            <Grid item md={5} xs={5}>
              <Typography className="fontweight500 font16 fontNormal">
                {vehicleData?.regNumber || "NA"}
              </Typography>
              <Typography className="font14">
                {vehicleData?.carModel || "NA"}
              </Typography>
              <Typography className="font14">
                <img
                  className="marginBottom5"
                  src={checkVerified}
                  alt="checkVerified"
                />
                Driver Vaccinated
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            flexDirection="row"
            justifyContent="space-evenly"
            alignItems="center"
            className="marginBlock30"
          >
            <Grid item>
              <a href={'tel:' + (authData?.mobile || "")}>
                <img src={greyCall} alt="greycall" />
              </a>
            </Grid>
            <Grid item>
              <Typography className="underline cursor" onClick={() => onPrivacyPolicy()}>
                <span>
                  <InfoIcon className="font20 marginBottom5" />
                </span>
                Read ITER's Privacy Notice
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={7.7} xs={12} className="mapView order2">
          {!isLoaded && tripStatus.toLowerCase() !== 'completed' ? (
            <h1>Loading...</h1>
          ) : tripStatus.toLowerCase() === 'completed' && tripDetails?.tripRouteImage?.url ? (
            <div className="h100p w100p">
              <img
                src={tripDetails.tripRouteImage.url}
                alt="Trip Route"
                className="w100p h100p object-fit-cover"
              />
            </div>
          ) : (
            <WrappedMap
              paths={[]}
              stops={stop}
              driverPathDetails={pathDetailsnew}
              googleMapURL={mapURL}
              loadingElement={<div className="h100p" />}
              containerElement={<div className="wh100" />}
              mapElement={<div className="h100p" />}
              status={tripStatus}
            />
          )}
        </Grid>
      </Grid>
      {!tripDetails?.DriverProfile && !tripDetails?.status &&(
        <Grid item>
          <CommonNoDataFound />
        </Grid>
      )}
    </>
  );
}

export default TripDetails;